import React from "react";
import "./TermConditions.css";
import { getData } from "app/data";

export default function Index() {
  const TermsConditions = getData("termsConditionsData");
  return (
    <div className="terms-conditions">
      <div className="container py-4 py-lg-6">
        <div className="row">
          <div className="col-md-9 col-centered">
            <h2>{TermsConditions.header.title}</h2>
            <p>{TermsConditions.header.text}</p>
            {TermsConditions.contents
              ? TermsConditions.contents.map((item) => {
                  return (
                    <>
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                    </>
                  );
                })
              : null}
            <h3>{TermsConditions.notice.title}</h3>
            <p>{TermsConditions.notice.text}</p>
            <ol>
              {TermsConditions.notice.list
                ? TermsConditions.notice.list.map((item) => {
                    return <li>{item}</li>;
                  })
                : null}
            </ol>
            <p>{TermsConditions.notice.p}</p>
            <ol>
              <li>{TermsConditions.notice.oneItem}</li>
            </ol>
            <p>{TermsConditions.notice.subtext}</p>
            <h3>{TermsConditions.additional.title}</h3>
            <ol>
              {TermsConditions.additional.list
                ? TermsConditions.additional.list.map((item) => {
                    return <li>{item}</li>;
                  })
                : null}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}